'use strict';

angular.module('adminEmailTemplatesControllers')

.controller('EditEmailTemplateController', ['$scope', '$state', 'adminEmailTemplatesService', 'emailTemplate', function ($scope, $state, adminEmailTemplatesService, emailTemplate) {

    $scope.ctxtEditEmail = {};
    $scope.ctxtEditEmail.needInliner = false;

    $scope.emailTemplate = emailTemplate;

    $scope.saveChanges = function () {
        var renderedTmpl = $('#previewHtml').html();
        var renderedTmplFR = $('#previewHtmlFR').html();

        adminEmailTemplatesService.getRenderedTemplateWithoutInliner($scope.emailTemplate.Code, renderedTmpl, renderedTmplFR)
        .then(function (beforeInliner) {
            $scope.ctxtEditEmail.beforeInliner = eval(beforeInliner);
            $scope.ctxtEditEmail.needInliner = true;
        });
    }

    $scope.saveChangesAfterInliner = function () {
        var markdownTmpl = $scope.emailTemplate.Template;
        var markdownTmplFR = $scope.emailTemplate.TemplateFR;
        var renderedTmpl = $scope.ctxtEditEmail.afterInliner;

        adminEmailTemplatesService.updateRenderedTemplate($scope.emailTemplate.Code, markdownTmpl, markdownTmplFR, renderedTmpl)
        .then(function () {
            $scope.ctxtEditEmail.beforeInliner = null;
            $scope.ctxtEditEmail.afterInliner = null;
            $scope.ctxtEditEmail.needInliner = false;
        });
    }

    $scope.copyInClipboard = function (inClipboard) {
        $scope.InClipboard = inClipboard;
    }
}]);
